module.exports = __webpack_public_path__ + "static/media/banesco-phone.a8569839.svg";